export const methods = [
  { value: "Frying", label: "Frying" },
  { value: "Deep Frying", label: "Deep Frying" },
  { value: "Baking", label: "Baking" },
  { value: "Fermenting", label: "Fermenting" },
  { value: "Cooking", label: "Cooking" },
];

export default methods;
